import { useEffect, useState } from 'react';
import axios from 'axios';
import Lastmenu2 from './LastMenu2';
import you from '../images/boy.png';
import bot from '../images/happy.png';
const Retailers = ({cityId}) => {
    const [partners, setPartners]=useState([]);
    const [time] =useState(new Date());
    
    useEffect(() => {
        axios
          .get(`https://dairy-api-kzjx.onrender.com/partner/${cityId}`) // Fetching cities from backend
          .then((response) => {
            if (response.data.partners?.length > 0) {
              setPartners(response.data.partners);
            } else {
              alert("No Retailers found.");
            }
          })
          .catch((error) => {
            console.error("Error fetching Retailers:", error);
            alert("Failed to fetch Retailers.");
          });
      }, []);
    
return(
    <>
<div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time?.toLocaleTimeString()}</div>
          <div className="you-message">
            <div className="frame2"><b>Submit</b></div>
          </div>

          <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
          </div>
        <div className="frame1">
        {/* <img src={image} className="IMAGE" alt="img" /> */}
            <div className="box1">

               {partners.map((partner)=>(
                <div style={{marginTop: '10px'}}>
                <b>Partner Name:</b>{partner.partner_name} <br></br>
                <b>Contact Number: </b>{partner.contact_number}<br></br>
                <b>Address:</b> {partner.address}<br></br>
                </div>
               ))}
            </div>
        </div>

        <Lastmenu2 />
        

    </>
);
}
export default Retailers;